import { getThumbnailImageUrl } from '@/components/ui/SearchResults/Snippets/helpers';
import { LargeCarouselItemProps } from './constants';

export const LargeCarouselGetCardColor = (url: string) => {
  const arr: string[] = url?.split('_') || [];
  const colorArr = arr.pop()?.split('.') || [];
  const color = colorArr[0] || '';
  return color;
};

export const getCarouselImageSource = (
  carouselProps: LargeCarouselItemProps,
  isLargeScreen?: boolean
) => {
  const imageUrl = carouselProps?.slideImage?.url || getThumbnailImageUrl(carouselProps?.code);
  const mobileImageUrl = carouselProps?.mobileImage?.url;

  if (isLargeScreen) {
    return imageUrl || mobileImageUrl;
  }
  return mobileImageUrl || imageUrl;
};
